/**
 * SparklineSkeleton — placeholder shown while session data loads from
 * IndexedDB. Matches the Sparkline's h-12 height so the layout doesn't
 * jump on hydration. Subtle — a thin baseline + a soft pulse so the user
 * knows something's coming, not a flashy spinner.
 */

import { type ReactNode } from "react";

export function SparklineSkeleton(): ReactNode {
  return (
    <div
      className="h-12 flex items-end gap-1 motion-safe:animate-pulse"
      role="status"
      aria-label="Loading recent activity"
    >
      {Array.from({ length: 14 }, (_, i) => (
        <div
          key={i}
          className="flex-1 bg-paperDeep"
          style={{ height: `${20 + ((i * 7) % 60)}%` }}
          aria-hidden
        />
      ))}
    </div>
  );
}
